/**
 * Shared badge tone helpers for Enrollment / Clinical Score / Eligibility
 * across the leads list and member detail header.
 *
 * Tones: green | orange | red | grey | unknown
 */

/**
 * @param {string|number|null|undefined} value
 * @returns {number|null}
 */
export function parseEnrollmentPercent(value) {
    if (value == null || value === "") {
        return null;
    }
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    const match = String(value).trim().match(/-?\d+(\.\d+)?/);
    if (!match) {
        return null;
    }
    const n = Number(match[0]);
    return Number.isFinite(n) ? n : null;
}

/**
 * Enrollment: <=30 red, 31–70 orange, >70 green.
 * @param {string|number|null|undefined} value
 * @returns {"red"|"orange"|"green"|"unknown"}
 */
export function getEnrollmentTone(value) {
    const pct = parseEnrollmentPercent(value);
    if (pct == null) {
        return "unknown";
    }
    if (pct <= 30) {
        return "red";
    }
    if (pct <= 70) {
        return "orange";
    }
    return "green";
}

/**
 * Clinical score: low → green, moderate/mid → orange, high → red.
 * @param {string|null|undefined} tierOrLabel
 * @returns {"green"|"orange"|"red"|"unknown"}
 */
export function getClinicalScoreTone(tierOrLabel) {
    const raw = String(tierOrLabel || "")
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, "");
    if (raw === "low" || raw === "peripheral" || raw === "periferal" || raw === "perifetal") {
        return "green";
    }
    if (raw === "mid" || raw === "medium" || raw === "moderate") {
        return "orange";
    }
    if (raw === "high" || raw === "core") {
        return "red";
    }
    return "unknown";
}

/**
 * Eligibility: Active → green, Rejected → red, else grey (Unavailable, Inactive, …).
 * @param {string|null|undefined} label
 * @returns {"green"|"red"|"grey"}
 */
export function getEligibilityTone(label) {
    const raw = String(label || "")
        .trim()
        .toLowerCase();
    if (raw === "active") {
        return "green";
    }
    if (raw === "rejected" || raw === "reject") {
        return "red";
    }
    return "grey";
}
